import "./BenevvTextField.css";

interface BenevvTextFieldProps {
  htmlFor: string;
  labelText?: string;
  placeholder: string;
  required: boolean;
  email?: boolean;
  password?: boolean;
  tel?: boolean;
  numeric?: boolean;
  styleLabel?: object;
  styleInput?: object;
  maxLength?: number;
  disabled?: boolean;
  multiline?: boolean;
  setTextField: (field: any) => void;
}

function BenevvTextField(props: BenevvTextFieldProps) {
  const {
    htmlFor,
    labelText,
    placeholder,
    required,
    email,
    password,
    tel,
    styleLabel,
    styleInput,
    setTextField,
    maxLength,
    disabled = false,
    numeric = false,
    multiline = false,
  } = props;
  const phonePattern =
    "^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$";

  const onlyDigits = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!/[0-9]/.test(e.key)) e.preventDefault();
  };
  let labelExist = true;
  if (labelText === undefined) {
    labelExist = false;
  }
  return (
    <>
      {labelExist && (
        <label htmlFor={htmlFor} className={"form-label"} style={styleLabel}>
          {" "}
          {labelText}{" "}
        </label>
      )}
      {multiline ? (
        <textarea
          id={htmlFor}
          placeholder={placeholder}
          style={styleInput}
          className={"form-input"}
          required={required}
          onChange={(e) => setTextField(e.currentTarget.value)}
          maxLength={maxLength}
          disabled={disabled}
          onKeyPress={numeric ? onlyDigits : undefined}
        />
      ) : (
        <input
          id={htmlFor}
          type={password ? "password" : email ? "email" : tel ? "tel" : "text"}
          placeholder={placeholder}
          style={styleInput}
          className={"form-input"}
          inputMode={numeric ? "numeric" : undefined}
          pattern={numeric ? "[0-9]*" : tel ? phonePattern : undefined}
          required={required}
          onChange={(e) => setTextField(e.currentTarget.value)}
          onKeyPress={numeric ? onlyDigits : undefined}
          maxLength={maxLength}
          disabled={disabled}
        />
      )}
    </>
  );
}

export default BenevvTextField;
